(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();


/* COIPLAY_BRAND_STORY_MEMORY_FIX_ASSET_20260612 */
(function () {
  function fixBrandStoryMemoryText() {
    if (window.location.pathname !== '/pages/brand-story') return;
    var cards = document.querySelectorAll('.coiplay-story-card');
    cards.forEach(function (card) {
      var heading = card.querySelector('h3');
      var paragraph = card.querySelector('p');
      if (!heading || !paragraph) return;
      if (heading.textContent.trim() === 'Pumpkin') {
        paragraph.textContent = 'Rescued at three months old, blind in one eye and battling skin disease. Bennie brought him with her when she immigrated to LA. Today he sleeps in the sun. Fat, happy, home.';
      }
      if (heading.textContent.trim() === 'In Loving Memory') {
        paragraph.innerHTML = '<strong>Milky &amp; Mini</strong> — Mini ran outside and was killed by a wolf; Milky ran outside and never came home. We couldn’t keep you safe, but we never forgot you. Every kit we make is a little bit because of you.';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBrandStoryMemoryText);
  } else {
    fixBrandStoryMemoryText();
  }
})();
